import { AxiosError } from 'axios';
import { useState } from 'react';

import { DateRangeOption } from '../../../models/dashboard/overview.model';
import { TimeseriesMetric, TimeseriesResponse } from '../../../models/dashboard/timeseries.model';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useDashboardTimeseries = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [timeseries, setTimeseries] = useState<TimeseriesResponse | null>(null);

  const onError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error(err?.response?.data?.message ?? 'Failed to load timeseries');
  };

  const onSuccess = ({ data }: SuccessHttpResponse<TimeseriesResponse>) => {
    setTimeseries(data);
  };

  const fetchTimeseries = (
    metric: TimeseriesMetric,
    range: DateRangeOption,
    startDate?: string,
    endDate?: string
  ) => {
    const url: HttpConfig = {
      url: 'api/v1/admin/dashboard/timeseries',
      method: 'get',
      params: {
        metric,
        range,
        ...(range === 'custom' ? { start_date: startDate, end_date: endDate } : {}),
      },
    };

    request(url, onSuccess, setLoading, onError);
  };

  return { timeseries, loading, fetchTimeseries };
};

export default useDashboardTimeseries;
